import { useEffect, useState } from "react";
import AppShell from "@/components/layout/AppShell";
import api from "@/lib/apiClient";
import { Drop, Package, Buildings } from "@phosphor-icons/react";

const ICONS = {
  "Presol":       { icon: Drop, tone: "sky" },
  "Minyak Bakar": { icon: Package, tone: "amber" },
  "Oli Bekas":    { icon: Buildings, tone: "slate" },
};

const TONE = {
  sky:   "bg-sky-50 border-sky-100 text-sky-900",
  amber: "bg-amber-50 border-amber-100 text-amber-900",
  slate: "bg-slate-50 border-slate-200 text-slate-900",
};

export default function StockSummaryPage() {
  const [rows, setRows] = useState([]);

  useEffect(() => { api.get("/stock/summary").then((r) => setRows(r.data)).catch(() => {}); }, []);

  return (
    <AppShell title="Ringkasan Stok" subtitle="Akumulasi stok Oli Bekas, Presol & Minyak Bakar dari hasil lab receiving">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {["Oli Bekas", "Presol", "Minyak Bakar"].map((p) => {
          const r = rows.find((x) => x.product === p) || { in: 0, out: 0, balance: 0 };
          const meta = ICONS[p] || ICONS["Oli Bekas"];
          return (
            <div key={p} className={`rounded-xl border p-5 shadow-sm ${TONE[meta.tone]}`}>
              <div className="flex items-start justify-between mb-4">
                <div>
                  <div className="text-[10px] font-bold uppercase tracking-[0.14em] opacity-70">Stok</div>
                  <div className="font-heading text-xl font-bold mt-1">{p}</div>
                </div>
                <meta.icon size={26} weight="duotone" className="opacity-80" />
              </div>
              <div className="font-heading font-black text-4xl leading-none">
                {r.balance.toLocaleString("id-ID", { maximumFractionDigits: 0 })}
                <span className="text-sm font-normal opacity-70 ml-1">liter</span>
              </div>
              <div className="grid grid-cols-2 gap-2 mt-4 pt-3 border-t border-current/10 text-[12px]">
                <div>
                  <div className="text-[10px] uppercase tracking-widest opacity-70">Masuk</div>
                  <div className="font-mono font-semibold">+ {r.in.toLocaleString("id-ID", { maximumFractionDigits: 0 })}</div>
                </div>
                <div>
                  <div className="text-[10px] uppercase tracking-widest opacity-70">Keluar</div>
                  <div className="font-mono font-semibold">− {r.out.toLocaleString("id-ID", { maximumFractionDigits: 0 })}</div>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <div className="mt-6 rounded-xl bg-white border border-slate-200 p-5 shadow-sm">
        <h3 className="font-heading text-sm font-bold uppercase tracking-wider text-slate-800 mb-2">Cara Akumulasi (Semua Satuan Liter)</h3>
        <ul className="text-sm text-slate-600 space-y-1 list-disc list-inside">
          <li><b>Liter Oli Bekas</b> = kilogram ÷ density</li>
          <li><b>Presol (L)</b> = Liter × <b>Yield Rate %</b></li>
          <li><b>Minyak Bakar (L)</b> = Liter × <b>Bensin %</b> (Minyak Bakar = Bensin)</li>
          <li>Water, Solar Jelek, Kotoran hanya metrik kualitas — tidak menambah stok.</li>
        </ul>
        <div className="mt-3 pt-3 border-t border-slate-100 text-[11.5px] text-slate-500 italic">
          <b>Contoh:</b> Timbangan 20.000 kg dengan density 0,87 → 22.988 L Oli Bekas.
          Yield 70% → Presol 16.091 L · Bensin 18% → Minyak Bakar 4.138 L.
        </div>
      </div>
    </AppShell>
  );
}
